import React, { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

import {
    Avatar,
    Box,
    Card,
    Typography
} from '@mui/material';
import KonsolLogo from '../components/logo/KonsolLogo';

export default function LoadingView(props) {
    const { selectedProject } = props

    const { user } = useAuth0();

    const [project, setProject] = useState({})

    useEffect(() => {
        setTimeout(() => {
            setProject(selectedProject)
        }, 1000)
    }, [selectedProject])

    return (
        <React.Fragment>
            <Box
                height={'100%'}
                width={'100%'}
                display={'flex'}
                position={'absolute'}
                top={0}
                right={0}
                bottom={0}
                left={0}
                justifyContent={'center'}
                alignItems={'center'}
            >
                <Card
                    sx={{
                        background: 'rgba(48, 89, 69, 0.2)',
                        borderRadius: '16px',
                        boxShadow: '0 4px 30px rgba(0, 0, 0, 0.5)',
                        backdropFilter: 'blur(4.5px)',
                        transitionProperty: 'box-shadow',
                        transitionDuration: '1s',
                        width: 400,
                        height: 540
                    }}
                >
                    <Box 
                        display={'flex'}
                        height={'100%'}
                        flexDirection={'column'}
                    >
                        <Box 
                            display={'flex'}
                            justifyContent={'center'}
                            pt={5}
                        >
                            <KonsolLogo
                                isLoading={true}
                                width={300}
                                height={76}
                            />
                        </Box>
                        <Box
                            display='flex'
                            justifyContent='center'
                            py={2}
                        >
                            <Typography
                                component="span"
                                variant="h6"
                                color="rgba(177,236, 175, 0.9)"
                            >
                                {`Welcome ${user?.name ?? ''}`}
                            </Typography>
                        </Box>
                        <Box 
                            display={'flex'}
                            justifyContent={'center'}
                        >
                            <Avatar
                                alt="Konsol"
                                src="/logo/konsol-k-icon.svg"
                                sx={{ 
                                    width: '160px', 
                                    height: '160px',
                                }}
                            />
                            <Avatar
                                alt="Production Image"
                                { ...project?.project_image &&
                                    { src: project?.project_image }
                                }
                                children={''} // If image broken, then fallback to empty string to avoid showing generic user icon
                                sx={{
                                    position: 'absolute',
                                    width: '160px', 
                                    height: '160px',
                                    backgroundColor: 'transparent',
                                    zIndex: -1,
                                    opacity: project?.project_image ? 1 : 0,
                                    transform: 'translateX(0%)',
                                    transitionProperty: 'opacity, transform',
                                    transitionDuration: '0.5s, 1s',
                                    transitionTimingFunction: 'ease-in ease-out',
                                    transitionDelay: '0s, 1s',
                                    '&.on': {
                                        opacity: '0',
                                        transform: 'translateX(-100%)'
                                    },
                                }}    
                            />
                        </Box>
                        <Box
                            py={2}
                            display='flex'
                            justifyContent='center'
                            sx={{
                                zIndex: 1, // Ensure it is above other elements
                                opacity: project?.project_db ? 1 : 0,
                                transitionProperty: 'opacity',
                                transitionDuration: '0.5s',
                                transitionTimingFunction: 'ease-in',
                                transitionDelay: '0s',
                                '&.on': {
                                    opacity: '0',
                                },
                            }}>
                                <Typography component="span" variant="h5" color="white">
                                    {project?.project_name ?? project?.project_db ?? ''}
                                </Typography>
                        </Box>
                    </Box>
                </Card>
            </Box>
        </React.Fragment>
    )
}